/**
 * My Tasks field Names
 * @type {Readonly<{date: string, totalHours: string, id: string, assignmentNumber: string, department: string, status: string}>}
 */
const fieldName = Object.freeze({
  taskQueueId: "taskQueueId",
  processName: "processName",
  activityType: "activityType",
  assignedTo: "assignedToName",
  initiatedBy: "initiatedByName",
  // initiateDate: "initiateDate",
  dueDate: "dueDate",
  remainingTime: "remainingTime"
});

/**
 *  My Tasks field Text
 * @type {Readonly<{date: string, totalHours: string, id: string, assignmentNumber: string, department: string, status: string}>}
 */
const fieldText = Object.freeze({
  taskQueueId: "Task Queue ID",
  processName: "Status",
  activityType: "Process",
  assignedTo: "Assigned To",
  initiatedBy: "Assigned By",
  // initiateDate: "Initiate Date",
  dueDate: "Due Date",
  remainingTime: "Remaining Time"
});

export { fieldName, fieldText };
